export default "__VITE_ASSET__b_ND6APoc6oUCHrIQ8LumQ__";